import { render } from "./AlzataRequiredIndicator.vue?vue&type=template&id=1a835ab4"
import script from "./AlzataRequiredIndicator.vue?vue&type=script&lang=js"
export * from "./AlzataRequiredIndicator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__